<template>
  <div class="site-contents dashboard d-flex align-items-center flex-wrap">
    <div class="container">
      <div class="event-lists events-wrap d-flex flex-wrap justify-content-between">
        <h2>My Wish lists</h2>
        <div v-if="!hosted && showSpinner == true" class="spinner">
          <div class="spinner-border dashboard-spinner" role="status"></div>
        </div>
        <div
          v-if="hostedResponse == true && totalHosted == 0 && showSpinner == false"
          class="event-lists align-center registry-lists get-started"
        >
          <div class="event-info w-100">
            <h4>
              You don’t have any wish lists!
              <br />Create your own now.
            </h4>
            <a
              data-toggle="modal"
              data-backdrop="static"
              data-keyboard="false"
              data-target="#create"
              href="#"
              class="btn btn-default"
            >Get Started</a>
          </div>
        </div>

        <a
          v-if="hosted"
          data-toggle="modal"
          data-backdrop="static"
          data-keyboard="false"
          data-target="#create"
          href="#"
          class="btn btn-default"
        >Create</a>
        <!-- Modal -->
        <div
          class="modal fade form-wrapper"
          id="create"
          tabindex="-1"
          role="dialog"
          aria-labelledby="formModalLabel"
          aria-hidden="true"
        >
          <div class="modal-dialog modal-lg" role="document">
            <div class="modal-content form-content">
              <div class="modal-body">
                <!-- if user can add events or is on trial -->
                <template
                  v-if="(userDetails.remainingEventsCount.freeEventsRemaining+userDetails.remainingEventsCount.purchasedEventsRemaining) > 0 || userDetails.remainingEventsCount.isOnTrial"
                >
                  <input
                    type="file"
                    ref="file"
                    style="display: none"
                    v-on:change="handleFileUpload()"
                  />

                  <div
                    class="img-upload d-flex flex-wrap align-items-centcd er justify-content-center"
                  >
                    <img
                      class="close"
                      src="assets/images/close.svg"
                      data-dismiss="modal"
                      aria-label="Close"
                      @click="resetForm()"
                    />
                    <img
                      v-if="imagePreview == null"
                      class="image-upload-icon"
                      src="assets/images/upload.svg"
                      @click="$refs.file.click()"
                    />
                    <img
                      v-if="imagePreview == null"
                      src="assets/images/plus.svg"
                      @click="$refs.file.click()"
                    />
                    <img v-if="cropped" v-bind:src="cropped" :class="{fullHeight:cropped != null}" />
                    <vue-croppie
                      v-show="imagePreview"
                      ref="croppieRef"
                      :enableOrientation="true"
                      :enforceBoundary="true"
                      :enableResize="false"
                      @result="result"
                      @update="update"
                      :enableExif="true"
                      :mouseWheelZoom="false"
                      :showZoomer="true"
                      :viewport="{ width: 322, height: 215, type: 'square' }"
                      :boundry="{ width: 600, height: 430}"
                    ></vue-croppie>
                    <!-- the result -->

                    <!-- <button @click="bind()">Bind</button> -->
                    <!-- Rotate angle is Number -->
                    <!-- <button @click="rotate(-90)">Rotate Left</button>
                    <button @click="rotate(90)">Rotate Right</button>-->
                    <button
                      v-if="imagePreview && !cropped"
                      class="btn btn-primary crop-button"
                      @click="cancelBanner()"
                    >
                      <i class="fa fa-times"></i>
                      Cancel
                    </button>
                    <button
                      v-if="cropped || cancelImage"
                      class="btn btn-primary crop-button"
                      @click="$refs.file.click()"
                    >
                      <i class="fa fa-upload"></i>
                      Change banner
                    </button>
                    <button
                      v-if="imagePreview && !cropped"
                      class="btn btn-primary crop-button crop"
                      style="right : 180px"
                      @click="crop()"
                    >
                      <i class="fa fa-crop"></i> Crop
                    </button>
                    <!-- <button @click="cropViaEvent()">Crop Via Event</button> -->
                  </div>
                  <div class="create-form">
                    <form
                      @submit.prevent="createWishlist"
                      id="createWishlist"
                      class="wishlistCreateForm"
                    >
                      <div class="form-group">
                        <input
                          type="text"
                          class="form-control"
                          name="name"
                          id="wishname"
                          data-vv-as="Wishlist Name"
                          v-model="name"
                          v-validate="'required|min:3|max:200'"
                          ref="name"
                          v-bind:class="{ 'is-invalid': errors.has('name')}"
                          placeholder="Wish list Name"
                        />
                        <div class="invalid-feedback">{{ errors.first('name') }}</div>
                      </div>
                      <div class="form-group">
                        <label for="celebrant">Celebrant Name</label>

                        <input
                          type="text"
                          class="form-control"
                          id="celebrant"
                          name="celebrant"
                          data-vv-as="Celebrant Name"
                          v-model="celebrant"
                          v-validate="'required|min:2|max:200'"
                          ref="celebrant"
                          v-bind:class="{ 'is-invalid': errors.has('celebrant')}"
                          placeholder="Timmy"
                        />
                        <div class="invalid-feedback">{{ errors.first('celebrant') }}</div>
                      </div>
                      <div class="dislike-like form-group">
                        <div class="likes">
                          <h5>Likes</h5>
                          <div class="more-btns">
                            <div class="addmore row">
                              <div class="col-md-10">
                                <input
                                  placeholder="Add Likes"
                                  ref="like"
                                  id="like"
                                  name="like"
                                  data-vv-as="like"
                                  class="form-control"
                                  v-model="like"
                                  v-validate="'min:3|max:50'"
                                  v-bind:class="{ 'is-invalid': errors.has('like')}"
                                />
                                <div class="invalid-feedback">{{ errors.first('like') }}</div>
                              </div>
                              <div class="col-md-2">
                                <button
                                  @click="clickLike()"
                                  type="button"
                                  class="btn btn-primary btn-sm"
                                >Add +</button>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="dislike form-group">
                          <h5>Dislikes</h5>
                          <div class="more-btns">
                            <div class="addmore row">
                              <!-- <v-chip-input
                              ref="dislike"
                              input-class="form-control"
                              v-model="dislike"
                              ></v-chip-input>-->
                              <div class="col-md-10">
                                <input
                                  placeholder="Add Dislikes"
                                  ref="dislike"
                                  name="dislike"
                                  data-vv-as="dislike"
                                  class="form-control"
                                  v-model="dislike"
                                  v-validate="'min:3|max:50'"
                                  v-bind:class="{ 'is-invalid': errors.has('dislike')}"
                                />
                                <div class="invalid-feedback">{{ errors.first('dislike') }}</div>
                              </div>
                              <div class="col-md-2">
                                <button
                                  type="button"
                                  class="btn btn-primary btn-sm"
                                  @click="clickDislike()"
                                >Add +</button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="form-group">
                        <label for="detail">Detail</label>
                        <textarea
                          class="form-control"
                          id="detail"
                          name="detail"
                          v-model="detail"
                          data-vv-as="detail"
                          v-validate="'min:3|max:250'"
                          ref="detail"
                          rows="1"
                          v-bind:class="{ 'is-invalid': errors.has('detail')}"
                          placeholder="Max 250 words"
                        ></textarea>
                        <span class="text-right">{{ detailCharacterCount }} / 250</span>
                        <div class="invalid-feedback">{{ errors.first('detail') }}</div>
                      </div>
                      <div class="form-group">
                        <label for="detail">Location</label>
                        <input
                          class="form-control"
                          id="location"
                          name="location"
                          v-model="location"
                          data-vv-as="Location"
                          
                          ref="location"
                          v-bind:class="{ 'is-invalid': errors.has('location')}"
                          placeholder="Event location"
                        />

                        <div class="invalid-feedback">{{ errors.first('location') }}</div>
                      </div>
                      <div
                        class="form-group form-time-date d-flex flex-wrap align-items-center justify-content-between"
                      >
                        <div class="form-group">
                          <label for="date">Date</label>
                          <datetime
                            class="theme-red"
                            data-vv-name="date"
                            v-validate="'required'"
                            v-bind:class="{ 'is-invalid': errors.has('date')}"
                            input-class="form-control"
                            :min-datetime="minDatetime"
                            v-model="date"
                          ></datetime>
                          <div class="invalid-feedback">{{ errors.first('date') }}</div>
                        </div>
                        <div class="form-group">
                          <label for="date">Time</label>
                          <datetime
                            class="theme-red"
                            data-vv-name="time"
                            format="HH:mm"
                            v-validate="'required'"
                            v-bind:class="{ 'is-invalid': errors.has('time')}"
                            input-class="form-control"
                            type="time"
                            :minute-step="15"
                            :min-datetime="minDatetime"
                            v-model="time"
                            use12-hour
                          ></datetime>

                          <div class="invalid-feedback">{{ errors.first('time') }}</div>
                        </div>
                      </div>

                      <div class="modal-footer form-footer justify-content-start flex-wrap">
                        <div
                          class="alert alert-success alert-dismissible"
                          :show="dismissCountDown"
                          dismissible
                          variant="success"
                          @dismissed="dismissCountDown=0"
                          @dismiss-count-down="countDownChanged"
                          v-if="apiSuccessMessage!=null"
                        >{{apiSuccessMessage}}</div>
                        <div
                          class="alert alert-danger alert-dismissible"
                          :show="dismissCountDown"
                          dismissible
                          variant="danger"
                          @dismissed="dismissCountDown=0"
                          @dismiss-count-down="countDownChanged"
                          v-if="apiErrorMessage!=null"
                        >{{ apiErrorMessage }}</div>
                        <div v-if="(showSpinner === true)" class="spinner-border" role="status"></div>
                        <button
                          type="submit"
                          class="btn btn-primary"
                          :disabled="disabled == true"
                        >{{ buttonText }}</button>
                        <p>Once you create the event you will be able to add guests and gifts to the event</p>
                      </div>
                    </form>
                  </div>
                </template>
                <!-- purchase events if no events available -->
                <template v-else>
                  <purchase-events></purchase-events>
                </template>
              </div>
            </div>
          </div>
        </div>

        <div
          v-for="(event,index) in hosted"
          class="registry-lists d-flex flex-wrap w-100"
          v-bind:key="event._id"
        >
          <div class="event-img">
            <img v-if="event.image" :src="event.image" />
            <img v-else src="../../public/assets/images/event1.png" />
          </div>
          <div
            class="event-info flex-grow-1"
            v-bind:class="{ bgWhite: ((index%2) !== 0 || index == 1) }"
          >
            <router-link :to="{ path: 'wishlist/'+event._id}">
              <h4>{{event.name}}</h4>
            </router-link>
            <div class="event-date">
              <template v-if="calculateDateDiff(event.date)">
                <p class="days-left">{{ new Date(event.date).toUTCString() | moment("from", "now")}}</p>
                <p class="date">{{ new Date(event.date).toString() | moment("DD/MM/YYYY")}}</p>
              </template>
              <p v-else>Your event has expired. Hope you had a great time.</p>
            </div>
            <div class="buy-bought">
              <p
                v-if="(event.totalGiftsPurchased > 0) && calculateDateDiff(event.date)"
              >{{ event.totalGiftsPurchased }} Gifts Purchased</p>
              <router-link v-else :to="{ path: 'wishlist/'+event._id}">
                <span v-if="calculateDateDiff(event.date)">Add a gift</span>
              </router-link>
            </div>
            <div class="dropdown dropdown-icon show">
             <span              
                type="button"
                id="dropdownMenuButton"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="true"
              ></span>
              <div class="dropdown-menu dropdown-menu-right show" aria-labelledby="dropdownMenuButton">
                <a
                  class="dropdown-item"
                  v-if="calculateDateDiff(event.date)"
                  @click="openShareModal(event._id)"
                >
                   <span class="text">Share</span>
                    <span class="icon-default"> <img src="../../public/assets/images/share.png" /></span>
                    <span class="icon-hover"> <img src="../../public/assets/images/share-hov.png" /></span>
                </a>
                <a class="dropdown-item" @click="archiveWishlist(index,event._id)">
                  <span class="text">Archive</span>
                    <span class="icon-default"> <img src="../../public/assets/images/archive.png" /></span>
                    <span class="icon-hover"> <img src="../../public/assets/images/archive-hov.png" /></span>
                </a>
                <a class="dropdown-item" @click="deleteWishlist(index,event._id)">
                   <span class="text">Delete</span>
                    <span class="icon-default"> <img src="../../public/assets/images/delete.png" /></span>
                    <span class="icon-hover"> <img src="../../public/assets/images/delete-hov.png" /></span>
                </a>
              </div>
              <share-wishlist :show="showShareModal" @closeShareModal="closeShareModal"></share-wishlist>
            </div>
          </div>
        </div>
        <router-link
          v-if="totalHosted > listTotal"
          to="/hosted"
          data-toggle="modal"
          class="view-all btn btn-default"
        >View all</router-link>
      </div>

      <div class="event-lists events-participating d-flex flex-wrap justify-content-between">
        <h2>Participating</h2>
        <div
          v-if="participatedResponse === true && totalParticipated === 0"
          class="event-lists align-center registry-lists join-now"
        >
          <div class="event-info w-100">
            <h4>Have an event code?</h4>
            <a href="#" class="btn btn-default" @click="openJoinByIdModal">Join Now</a>
          </div>
        </div>
        <a v-if="participated" href="#" class="btn btn-default" @click="openJoinByIdModal">Join</a>
        <join-by-id :show="showJoinByIdModal" @closeModal="closeJoinByIdModal"></join-by-id>

        <div
          v-for="(event,index) in participated"
          v-bind:key="event._id"
          class="registry-lists d-flex flex-wrap w-100"
        >
          <div class="event-img">
            <img v-if="event.image" :src="event.image" />
            <img v-else src="../../public/assets/images/event1.png" />
          </div>
          <div
            class="event-info flex-grow-1"
            v-bind:class="{ bgWhite: ((index%2) !== 0 || index == 1) }"
          >
            <router-link :to="{ path: 'wishlist/'+event._id}">
              <h4>{{event.name}}</h4>
            </router-link>
            <div class="event-date">
              <template v-if="calculateDateDiff(event.date)">
                <p class="days-left">{{ new Date(event.date).toString() | moment("from", "now")}}</p>
                <p class="date">{{ new Date(event.date).toString() | moment("DD/MM/YYYY")}}</p>
              </template>
              <p v-else>This event has expired. Hope you had a great time.</p>
            </div>
            <div class="buy-bought">
              <p
                v-if="(event.totalGiftsPurchased > 0) && calculateDateDiff(event.date)"
              >{{ event.totalGiftsPurchased }} Gifts Purchased</p>
              <router-link v-else :to="{ path: 'wishlist/'+event._id}">
                <span v-if="calculateDateDiff(event.date)">Add a gift</span>
              </router-link>
            </div>
            <!-- <div class="dropdown">
              <span
                class="dropdown-toggle"
                type="button"
                id="dropdownMenuButton"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
              ></span>
              <div class="dropdown-menu dropdown-menu-right" aria-labelledby="dropdownMenuButton">
                <a
                  v-if="calculateDateDiff(event.date)"
                  class="dropdown-item"
                  @click="openShareModal(event._id)"
                >Share</a>

                <a
                  class="dropdown-item"
                  @click="archiveParticipatedWishlist(index,event._id)"
                >Archive</a>
              </div>
              <share-wishlist :show="showShareModal" @closeShareModal="closeShareModal"></share-wishlist>
            </div>-->
          </div>
        </div>
        <router-link
          v-if="totalParticipated > listTotal"
          to="/participated"
          data-toggle="modal"
          class="view-all btn btn-default"
        >View all</router-link>
      </div>
    </div>
    <div
      class="modal more-guest-list"
      id="confirm-delete"
      tabindex="-1"
      role="dialog"
      aria-labelledby="myModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h5 v-if="isArchive === true">Archive event</h5>
            <h5 v-else>Delete event</h5>
            <img
              class="close"
              src="../../public/assets/images/close.svg"
              data-dismiss="modal"
              aria-label="Close"
            >
      </div>
          <div class="modal-body">
            <h4>Are you sure?</h4></div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-dismiss="modal">No</button>
            <button
              type="button"
              class="btn btn-primary"
              v-model="confirmed"
              @click="confirmTrue()"
            >Yes</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<style>
.addmore a {
  padding-bottom: 10px;
}
.crop-button {
  margin-left: 500px;
  margin-top: 10px;
}
.wishlistCreateForm {
  margin-top: 0px !important;
}
</style>
<script>
import { Vuex, mapState } from "vuex";
import Vue from "vue";
//import actions
import {
  GET_HOSTED_WISHLIST,
  GET_PARTICIPATED_WISHLIST,
  CREATE_WISHLIST,
  DELETE_WISHLIST,
  ARCHIVE_WISHLIST,
  UPLOAD_WISHLIST_IMAGE,
  STORE_SHARE_EVENTID,
  JOIN_WISHLIST_BY_UNIQUECODE,
  GET_REMAINING_EVENTS_COUNT,
  GET_EVENT_PRICING
} from "../store/wishlist/action.type";

//import mutations
import { SET_REMAINING_EVENTS_COUNT_MUTATION } from "../store/auth/mutation.type";
import { SET_EVENT_PRICING_MUTATION } from "../store/wishlist/mutation.type";

import { Validator } from "vee-validate";
import VChip from "v-chip";
import VChipInput from "v-chip/src/v-chip-input.js";
import VueCroppie from "vue-croppie";
import "croppie/croppie.css"; // import the croppie css manually

import ShareWishlist from "./ShareWishlist";
import JoinById from "./JoinById";
import PurchaseEvents from "./payment/PurchaseEvents";

Vue.use(VueCroppie);
Vue.use(VChip);
Vue.use(VChipInput);

export default {
  name: "webDashboard",
  components: {
    "share-wishlist": ShareWishlist,
    "join-by-id": JoinById,
    "purchase-events": PurchaseEvents
  },
  data() {
    return {
      hosted: null,
      participated: null,
      listTotal: process.env.VUE_APP_API_PER_PAGE_LIMIT || 3,
      totalHosted: 0,
      totalParticipated: 0,
      hostedResponse: false,
      participatedResponse: false,
      name: null,
      image: "",
      celebrant: null,
      location: null,
      detail: null,
      date: null,
      time: null,
      dateOffset: null,
      like: null,
      dislike: null,
      likes: [],
      dislikes: [],
      apiErrorMessage: null,
      apiSuccessMessage: null,
      dismissSecs: 5,
      dismissCountDown: 0,
      uniqueCode: null,
      showSpinner: true,
      disabled: null,
      buttonText: "Create Event",
      cancelImage: false,

      //for croppie
      cropped: null,
      file: "",
      showPreview: false,
      imagePreview: null,

      //wihlist actions
      index: null,
      id: null,
      isDelete: false,
      isArchive: false,
      isShare: false,
      confirmed: false,
      wishlistType: null,
      minDatetime: new Date().toISOString(),
      /*SHARE WISHLIST */
      showShareModal: false,
      //paginate
      page: 1,
      perPageLimit: process.env.VUE_APP_API_PER_PAGE_LIMIT || 3,

      /* JOIN WISHLIST BY UNIQUE ID */
      showJoinByIdModal: false
    };
  },
  created() {
    //define default functions
    window.removeLikes = this.removeLikes;
    window.removeDislikes = this.removeDislikes;
  },
  computed: {
    detailCharacterCount() {
      let char = this.detail;
      if (char) {
        return char.length;
      } else {
        return 0;
      }
      selectedDate;
    },
    ...mapState({
      userDetails: state => state.auth.userDetails
    })
  },
  watch: {
    date: {
      handler: function(newValue, oldValue) {
        let currentDate = new Date();

        let utcHours = new Date(currentDate).getHours();
        let utcMinutes = new Date(currentDate).getMinutes();

        let selectedDate = new Date(newValue);
        selectedDate.setHours(utcHours);
        selectedDate.setMinutes(utcMinutes);

        if (selectedDate) {
          this.time = new Date(selectedDate).toISOString();

          this.minDatetime = new Date().toISOString();
        }
      }
    }
  },
  mounted() {
    //destroy croppie
    let params = {
      page: this.page,
      perPageLimit: this.perPageLimit
    };

    //get wishlists
    this.getHostedWishlist(params);
    this.getParticipatedWishlist(params);

    //get event prices
    this.$store
      .dispatch(GET_EVENT_PRICING, params)
      .then(response => {
        //update state to display counts in navigation bar
        this.$store.commit(SET_EVENT_PRICING_MUTATION, response);
      })
      .catch(error => {
        console.log(error);
      });
    //get remaining events
    this.$store
      .dispatch(GET_REMAINING_EVENTS_COUNT, params)
      .then(response => {
        // console.log(response);
        //update state to display counts in navigation bar
        this.$store.commit(SET_REMAINING_EVENTS_COUNT_MUTATION, response);
      })
      .catch(error => {
        console.log(error);
      });

    this.refresh();
    // //croppie
    // this.$refs.croppieRef.bind({
    //   url: this.imagePreview
    // });
  },
  methods: {
    countDownChanged(dismissCountDown) {
      this.dismissCountDown = dismissCountDown;
    },
    showAlert() {
      this.dismissCountDown = this.dismissSecs;
    },
    arrayToObject(array) {
      let object = [];
      for (let a of array) {
        object.push({ item: a });
      }
      return object;
    },
    //hosted wishlist
    getHostedWishlist(params) {
      //get hosted events
      this.$store
        .dispatch(GET_HOSTED_WISHLIST, params)
        .then(response => {
          this.hostedResponse = true;
          // console.log(response);
          this.hosted = response.record;
          this.totalHosted = response.pagination.totalDocs;
          this.showSpinner = false;
        })
        .catch(error => {
          console.log(error);
          this.showSpinner = false;
        });
    },
    //participated wishlist
    getParticipatedWishlist(params) {
      //get participated events
      this.$store
        .dispatch(GET_PARTICIPATED_WISHLIST, params)
        .then(response => {
          this.participatedResponse = true;
          // console.log(response);
          if (response) {
            this.participated = response.record;
            this.totalParticipated = response.pagination.totalDocs;
            this.showSpinner = false;
          }
        })
        .catch(error => {
          console.log(error);
          this.showSpinner = false;
        });
    },

    createWishlist(e) {
      // create wishlist
      this.$validator.validateAll().then(valid => {
        if (valid) {
          this.showSpinner = true;
          this.disabled = true;
          this.buttonText = "Creating Event...";
          if (this.cropped) {
            this.uploadImage();
          } else {
            this.saveCreatedWishlist();
          }
        }
      });
    },
    uploadImage() {
      // upload cropped image
      const uploadBody = {
        image: this.cropped
      };
      if (this.cropped) {
        this.$store
          .dispatch(UPLOAD_WISHLIST_IMAGE, uploadBody)
          .then(response => {
            if (response.status == 200) {
              // console.log(response.data.data.file);
              // this.apiSuccessMessage = response.data.message;
              // this.apiErrorMessage = null;
              this.image = response.data.data.file;
            } else {
              this.showSpinner = null;
              this.disabled = null;
              this.buttonText = "Create Event";
              this.apiErrorMessage = response.data.message;
              this.apiSuccessMessage = null;
            }
            this.showAlert();
            this.saveCreatedWishlist();
          })
          .catch(error => {
            console.log(error);
          });
      }
    },

    /*
    Handles a change on the file upload
  */
    saveCreatedWishlist() {
      //upload image

      // let utcTime = new Date(this.time).getTime();
      let utcHours = new Date(this.time).getHours();
      let utcMinutes = new Date(this.time).getMinutes();

      let utcDate = new Date(this.date);

      utcDate.setHours(utcHours);
      utcDate.setMinutes(utcMinutes);
      let currentDate = new Date();

      // console.log(new Date(utcDate).toString());
      this.dateOffset = currentDate.getTimezoneOffset();

      this.apiErrorMessage = null;

      // check one hour ahead from now
      let checkTime = currentDate.setHours(currentDate.getHours() + 1);
      if (new Date(utcDate) <= checkTime) {
        this.apiErrorMessage =
          "Please select event date time with at least one hour margin.";
        this.buttonText = "Create Event";
        this.disabled = null;
        this.showSpinner = null;
        return false;
      }
      const body = {
        name: this.name,
        celebrantInformation: this.celebrant,
        address: this.location,
        date: new Date(utcDate),
        dateOffset: String(this.dateOffset),
        likes: this.arrayToObject(this.likes),
        dislike: this.arrayToObject(this.dislikes)
      };
      if (this.detail) {
        body.detail = this.detail;
      }
      //image not compulsory
      if (this.image) {
        body.image = this.image;
      }

      // console.log(body);
      /* save other data after image upload */
      this.$store
        .dispatch(CREATE_WISHLIST, body)
        .then(response => {
          if (response.status == 200) {
            // console.log(response);
            this.apiSuccessMessage = response.data.message;
            this.apiErrorMessage = null;

            this.$router.go("dashboard");
          } else {
            console.log(response.data.message);
            this.apiErrorMessage = response.data.message;
            this.apiSuccessMessage = null;
          }
          //reset params
          this.showSpinner = null;
          this.disabled = null;
          this.buttonText = "Create Event";
        })
        .catch(error => {
          console.log(error);
          this.apiErrorMessage = error.response.data.message;
          this.apiSuccessMessage = null;
          //reset params
          this.showSpinner = null;
          this.disabled = null;
          this.buttonText = "Create Event";
        });
    },
    handleFileUpload() {
      /*
      Set the local file variable to what the user has selected.
    */
      this.imagePreview = null;
      this.cancelImage = false;
      this.cropped = null;
      this.file = this.$refs.file.files[0];

      /*
      Initialize a File Reader object
    */
      let reader = new FileReader();

      /*
      Add an event listener to the reader that when the file
      has been loaded, we flag the show preview as true and set the
      image to be what was read from the reader.
    */
      reader.addEventListener(
        "load",
        function() {
          this.showPreview = true;
          this.imagePreview = reader.result;

          this.initCroppie();
          this.$refs.croppieRef.bind({
            url: this.imagePreview
          });
        }.bind(this),
        false
      );

      /*
      Check to see if the file is not empty.
    */
      if (this.file) {
        /*
        Ensure the file is an image file.
      */
        if (/\.(jpe?g|png|gif)$/i.test(this.file.name)) {
          /*
          Fire the readAsDataURL method which will read the file in and
          upon completion fire a 'load' event which we will listen to and
          display the image in the preview.
        */
          reader.readAsDataURL(this.file);
          this.file = "";
        }
        this.refresh();
      }
    },
    //settings for croppie
    // bind() {
    //   // Randomize cat photos, nothing special here.
    //   let url = this.images[Math.floor(Math.random() * 4)];

    //   // Just like what we did with .bind({...}) on
    //   // the mounted() function above.
    //   this.$refs.croppieRef.bind({
    //     url: url
    //   });
    // },
    // CALBACK USAGE
    crop() {
      // Here we are getting the result via callback function
      // and set the result to this.cropped which is being
      // used to display the result above.
      let options = {
        format: "jpeg",
        circle: false,
        size: { width: 1028 }
      };
      this.$refs.croppieRef.result(options, output => {
        this.cropped = output;
      });

      this.refresh();
    },
    // EVENT USAGE
    cropViaEvent() {
      this.$refs.croppieRef.result(options);
    },
    result(output) {
      this.cropped = output;
    },
    update(val) {
      // console.log(val);
    },
    rotate(rotationAngle) {
      // Rotates the image
      this.$refs.croppieRef.rotate(rotationAngle);
    },
    refresh() {
      if (this.$refs.croppieRef) {
        this.$refs.croppieRef.destroy();
      }
    },
    initCroppie() {
      this.$refs.croppieRef.initCroppie();
    },
    /*delete wishlist */
    deleteWishlist(index, id) {
      $("#confirm-delete").modal("show");
      this.index = index;
      this.id = id;
      this.wishlistType = "hosted";
      this.isDelete = true;
      this.isShare = false;
      this.isArchive = false;
    },
    shareWishlist(id) {},
    archiveWishlist(index, id) {
      $("#confirm-delete").modal("show");
      this.index = index;
      this.id = id;
      this.wishlistType = "hosted";
      this.isDelete = false;
      this.isShare = false;
      this.isArchive = true;
    },
    shareParticipatedWishlist() {},
    archiveParticipatedWishlist(index, id) {
      $("#confirm-delete").modal("show");
      this.index = index;
      this.id = id;
      this.wishlistType = "participated";
      this.isDelete = false;
      this.isShare = false;
      this.isArchive = true;
    },
    confirmTrue() {
      $("#confirm-delete").modal("hide");
      //destroy croppie
      let params = {
        page: this.page,
        perPageLimit: this.perPageLimit
      };
      if (this.isDelete) {
        /* delete wishlist api */
        this.$store
          .dispatch(DELETE_WISHLIST, this.id)
          .then(response => {
            if (response.status == 200) {
              this.$delete(this.hosted, this.index);
            } else {
            }
          })
          .catch(error => {
            console.log(error);
          });

        this.getHostedWishlist(params);
        this.getParticipatedWishlist(params);

        // this.$router.go(this.$router.currentRoute);
      } else if (this.isArchive) {
        /* delete wishlist api */
        this.$store
          .dispatch(ARCHIVE_WISHLIST, this.id)
          .then(response => {
            if (response.status == 200) {
              if (this.wishlistType === "hosted") {
                this.$delete(this.hosted, this.index);
              } else {
                this.$delete(this.participated, this.index);
              }
            } else {
            }
          })
          .catch(error => {
            console.log(error);
          });

        this.getHostedWishlist(params);
        // this.$router.go(this.$router.currentRoute);
      } else {
      }
    },

    resetForm() {
      document.getElementById("createWishlist").reset();
      this.errors.clear();
      this.cropped = null;
      this.showPreview = false;
      this.imagePreview = null;
      this.refresh();
    },

    openShareModal(eventId) {
      this.showShareModal = true;
      this.$store.dispatch(STORE_SHARE_EVENTID, eventId);
    },

    closeShareModal() {
      //set the showShareModal value to false so that modal will hide in child
      this.showShareModal = false;
    },

    /* JOIN WISHLIST BY UNIQUE ID */
    openJoinByIdModal() {
      this.showJoinByIdModal = true;
    },

    closeJoinByIdModal() {
      this.showJoinByIdModal = false;
    },
    //add likes
    clickLike() {
      this.$validator.validate("like", this.like).then(success => {
        // submit the value
        if (this.like && $.inArray(this.like, this.likes) == -1 && success) {
          let display = "'none'";
          let appendChips =
            '<div class="chip-wrapper"><div index="0" class="chip" style="color: rgb(51, 51, 51); background-color: rgb(241, 241, 241);"><span class="chip-item">';
          appendChips += this.like;
          appendChips +=
            '</span><span onclick="removeLikes(this)" class="closebtn">×</span></div></div>';
          $(".likes .addmore").prepend(appendChips);

          this.likes.push(this.like);
          this.like = null;
          this.$refs.like.focus();
        }
      });
    },

    removeLikes($this) {
      //remove from array
      var index = this.likes.indexOf(
        $($this)
          .prev(".chip-item")
          .text()
      );
      if (index !== -1) {
        this.likes.splice(index, 1);
      }
      $($this)
        .parent()
        .remove();
      this.$refs.like.focus();
    },
    //add dislikes
    clickDislike() {
      this.$validator.validate("dislike", this.dislike).then(success => {
        if (
          this.dislike &&
          $.inArray(this.dislike, this.dislikes) == -1 &&
          success
        ) {
          let display = "'none'";
          let appendChips =
            '<div class="chip-wrapper"><div index="0" class="chip" style="color: rgb(51, 51, 51); background-color: rgb(241, 241, 241);"><span class="chip-item">';
          appendChips += this.dislike;
          appendChips +=
            '</span><span onclick="removeDislikes(this)" class="closebtn">×</span></div></div>';
          $(".dislike .addmore").prepend(appendChips);

          this.dislikes.push(this.dislike);
          this.dislike = null;
          this.$refs.dislike.focus();
        }
      });
    },

    removeDislikes($this) {
      //remove from array
      var index = this.dislikes.indexOf(
        $($this)
          .prev(".chip-item")
          .text()
      );
      if (index !== -1) {
        this.dislikes.splice(index, 1);
      }
      $($this)
        .parent()
        .remove();
      this.$refs.dislike.focus();
    },
    // calculate date difference for the wishlist
    calculateDateDiff(date) {
      let eventDate = new Date(date);
      let currentDate = new Date();
      if (eventDate - currentDate > 0) {
        return true;
      } else {
        return false;
      }
    },
    cancelBanner() {
      this.refresh();
      this.imagePreview = null;
      this.cropped = null;
      this.cancelImage = true;
    }
  }
};
</script>